<template>
  <div class="min-h-screen flex flex-col bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
    <!-- Navbar -->
    <header class="sticky top-0 z-50 bg-white/80 dark:bg-gray-800/80 backdrop-blur-md shadow-sm">
      <nav class="container-fluid fm:mx-3 mx-14 sm:px-6 fd:px-8 flex items-center justify-between h-16">
        <div class="flex items-center justify-between fm:gap-4 gap-10">
            <!-- Burger icon -->
             <div>
                <button class="fm:block hidden p-2 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-700 transition" @click="toggleSidebar()">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-700 dark:text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                </button>
             </div>
            <!-- Logo -->
            <!-- <div class="flex items-center fm:text-sm">
                <svg class="w-8 h-8 text-indigo-600 dark:text-indigo-400" fill="none" stroke="currentColor" stroke-width="2"
                    viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6l4 2" />
                    <circle cx="12" cy="12" r="10" />
                </svg>
            </div> -->

            <!-- Menu -->
            <ul :class="[showSidebar ? 'fm:flex' : 'fm:hidden', 'fm:absolute fm:top-16 fm:left-0 fm:w-full fm:bg-white fm:dark:bg-gray-800 fm:shadow-md fm:flex-col fm:space-y-4 fm:p-4 fm:transition-all fm:duration-300', 'flex gap-10']">
            <!-- <li><router-link to="/" class="text-gray-700 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400 transition">خانه</router-link></li>
            <li><router-link to="/products" class="text-gray-700 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400 transition">محصولات</router-link></li>
            <li><router-link to="/about" class="text-gray-700 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400 transition">درباره ما</router-link></li>
            <li><router-link to="/contact" class="text-gray-700 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400 transition">تماس</router-link></li> -->
            </ul>
        </div>

        <div class="flex items-center gap-6">
            <div class="p-2 bg-gray-200 dark:bg-gray-700 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition">
                <router-link v-if="!$store.state.user.token" to="/login" class="text-gray-700 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400 transition fm:text-sm">ورود/ثبت نام</router-link>
                <router-link v-else to="/dashboard" class="text-gray-700 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400 transition fm:text-sm">پنل کاربری</router-link>
            </div>
            <!-- Right: Theme Toggle -->
            <div class="flex items-center space-x-4">
                <button @click="toggleDarkMode" class="p-2 rounded-lg bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 transition fm:text-sm">
                    <svg v-if="!isDark" xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-800" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 3v1m0 16v1m8.66-8.66h-1M4.34 12H3m15.36 5.36l-.7-.7M6.34 6.34l-.7-.7m12.02 12.02l-.7-.7M6.34 17.66l-.7-.7M12 5a7 7 0 000 14a7 7 0 000-14z" />
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-yellow-400" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 12.79A9 9 0 1111.21 3a7 7 0 009.79 9.79z" />
                    </svg>
                </button>
            </div>
        </div>
      </nav>
    </header>

    <!-- Main Content -->
    <main class="fm:mx-4">
      <router-view></router-view>
    </main>

    <!-- Footer -->
    <footer class="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
      <div class="max-w-7xl mx-auto py-6 sm:px-6 fd:px-8 flex flex-col sm:flex-row justify-between items-center text-gray-600 dark:text-gray-300 text-sm">
        <p class="mb-2 sm:mb-0">&copy; {{ new Date().getFullYear() }}  همه حقوق محفوظ است.</p>
        <div class="flex gap-10">
          <!-- <a href="#" class="hover:text-indigo-600 dark:hover:text-indigo-400 transition">اینستاگرام</a>
          <a href="#" class="hover:text-indigo-600 dark:hover:text-indigo-400 transition">تلگرام</a>
          <a href="#" class="hover:text-indigo-600 dark:hover:text-indigo-400 transition">لینکدین</a> -->
        </div>
      </div>
    </footer>
  </div>
</template>


<script>
    export default {
        name: 'FrontLayout',
    }
</script>

<script setup>

import { onMounted, ref, watch } from 'vue';


let isDark = ref(false);
let showSidebar = ref(false)

onMounted(() => {
    if (localStorage.getItem('dark-mode') === 'true') {
        isDark.value = true
        document.documentElement.classList.add('dark')
    } else {
        isDark.value = false
        document.documentElement.classList.remove('dark')
    }
})

function toggleDarkMode() {
    isDark.value = !isDark.value
    localStorage.setItem('dark-mode', isDark.value)
    if (isDark.value) {
        document.documentElement.classList.add('dark')
    } else {
        document.documentElement.classList.remove('dark')
    }
}

function toggleSidebar(){
    showSidebar.value = !showSidebar.value
}
</script>